import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, lifecycle, withStateHandlers } from 'recompose';

import { makeEstimationMessage } from 'modules/conference/selectors/etimatedTimeMessageFormattor';
import { getInternalAppointmentStatus } from 'modules/appointmentInfo/selectors/internalAppointmentStatus';
import { getReadCurrentAppointmentPermissions, isFullPrerequisiteIncomplete } from 'modules/appointmentInfo/selectors/currentAppointment';
import { getAppointmentsEstimatedTimeToBeServedSelector } from 'modules/queues/Schedule/selectors/appointments';
import { getUpcomingDiffTime } from 'shared/utils/dateTimeUtils';

import AppointmentDescriptionPlaceholder from './AppointmentDescriptionPlaceholder';

const intervalTime = 1000;

const mapStateToProps = (state) => {
  const { currentAppointment } = state.appointmentInfo;

  const { startTime, endTime } = currentAppointment.schedules[0];
  const { status, service: { config: { queueType } } } = currentAppointment;
  const estimatedTimeObject = getAppointmentsEstimatedTimeToBeServedSelector(state)[currentAppointment.appointmentId];

  const permissions = getReadCurrentAppointmentPermissions(state);

  const internalStatus = getInternalAppointmentStatus(state);

  return {
    startTime,
    endTime,
    status,
    internalStatus,
    permissions,
    queueType,
    expectedTime: makeEstimationMessage(estimatedTimeObject),
    prerequisitesIncomplete: isFullPrerequisiteIncomplete(state),
  };
};

export default compose(
  connect(mapStateToProps),
  withStateHandlers(
    { expectedMinutes: null },
    {
      expectedMinutesUpdater:
        (_, { expectedTime }) => () => ({ expectedMinutes: getUpcomingDiffTime(Number(expectedTime.estimatedTimestamp)) }),
    },
  ),
  lifecycle({
    componentDidMount() {
      if (this.props.expectedTime.withTimer) {
        this.props.expectedMinutesUpdater(null, this.props);
        this.timer = setInterval(this.props.expectedMinutesUpdater, intervalTime);
      }
    },

    componentDidUpdate() {
      if (this.props.expectedTime.withTimer && new Date().getTime() > this.props.expectedTime.estimatedTimestamp && this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    componentWillReceiveProps({ expectedTime }) {
      if (expectedTime.estimatedTimestamp !== this.props.expectedTime.estimatedTimestamp &&
        expectedTime.withTimer && !this.timer) {
        this.timer = setInterval(this.props.expectedMinutesUpdater, intervalTime);
      }
    },

    componentWillUnmount() {
      clearInterval(this.timer);
    },
  }),
  injectIntl,
)(AppointmentDescriptionPlaceholder);

